import { useState } from 'react'
import { CS_URL } from '../constants'
import { Row } from './flex'

export const Footer = () => {
    const [showOtherSites, setShowOtherSites] = useState(false)
    return (
        <footer className="cs-site-footer">
            <div className="footer-top-wrapper">
                <div
                    id="p_lt_ctl02_CS_FooterLinks_pnlCTA"
                    className="footer-cta-wrapper">
                    <div className="footer-heading">
                        <h4>Book faster and stay informed:</h4>
                    </div>
                    <div className="btn-wrap">
                        <a
                            id="p_lt_ctl02_CS_FooterLinks_hypLink"
                            className="cs-primary-button"
                            href={`${CS_URL}/account/sign-in`}>
                            Sign in/Sign up
                        </a>
                    </div>
                </div>
                <div className="cs-footer-social-links-wrapper">
                    <ul className="cs-footer-social-links">
                        <li>
                            <a
                                id="p_lt_ctl02_CS_FooterLinks_smInstagram"
                                className="cs-icon-instagram"
                                title="Instagram"
                                href="https://www.instagram.com/citysprintuk/">
                                <span className="icon-social-media">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="39.07"
                                        height="39.069"
                                        viewBox="0 0 39.07 39.069">
                                        <g transform="translate(0 0)">
                                            <path
                                                className="a"
                                                d="M1675.734,6208.057c5.217,0,5.834.02,7.895.114a10.775,10.775,0,0,1,3.627.672,6.461,6.461,0,0,1,3.708,3.707,10.76,10.76,0,0,1,.672,3.628c.094,2.061.114,2.678.114,7.894s-.02,5.834-.114,7.894a10.772,10.772,0,0,1-.672,3.628,6.474,6.474,0,0,1-3.708,3.708,10.826,10.826,0,0,1-3.627.672c-2.059.094-2.678.113-7.895.113s-5.833-.02-7.893-.113a10.851,10.851,0,0,1-3.629-.672,6.488,6.488,0,0,1-3.708-3.708,10.861,10.861,0,0,1-.672-3.628c-.094-2.06-.114-2.677-.114-7.894s.02-5.833.114-7.894a10.849,10.849,0,0,1,.672-3.628,6.476,6.476,0,0,1,3.708-3.707,10.8,10.8,0,0,1,3.629-.672c2.059-.095,2.678-.114,7.893-.114m0-3.52c-5.305,0-5.969.021-8.053.117a14.3,14.3,0,0,0-4.742.907,9.994,9.994,0,0,0-5.713,5.715,14.345,14.345,0,0,0-.909,4.741c-.094,2.083-.117,2.749-.117,8.054s.023,5.972.117,8.055a14.35,14.35,0,0,0,.909,4.741,9.983,9.983,0,0,0,5.713,5.713,14.345,14.345,0,0,0,4.742.909c2.084.1,2.748.117,8.053.117s5.971-.021,8.055-.117a14.354,14.354,0,0,0,4.742-.909,9.985,9.985,0,0,0,5.713-5.713,14.312,14.312,0,0,0,.907-4.741c.1-2.083.118-2.749.118-8.055s-.022-5.971-.118-8.054a14.307,14.307,0,0,0-.907-4.741,10,10,0,0,0-5.713-5.715,14.309,14.309,0,0,0-4.742-.907c-2.084-.1-2.75-.117-8.055-.117Z"
                                                transform="translate(-1656.199 -6204.537)"
                                            />
                                            <path
                                                className="a"
                                                d="M1671.9,6210.2a10.032,10.032,0,1,0,10.032,10.032A10.032,10.032,0,0,0,1671.9,6210.2Zm0,16.543a6.511,6.511,0,1,1,6.513-6.511A6.511,6.511,0,0,1,1671.9,6226.747Z"
                                                transform="translate(-1652.363 -6200.701)"
                                            />
                                            <circle
                                                className="a"
                                                cx="2.344"
                                                cy="2.344"
                                                r="2.344"
                                                transform="translate(27.619 6.762)"
                                            />
                                        </g>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                id="p_lt_ctl02_CS_FooterLinks_smTwitter"
                                className="cs-icon-twitter"
                                title="Twitter"
                                href="https://twitter.com/CitySprint_UK">
                                <span className="icon-social-media">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="37.183"
                                        height="30.217"
                                        viewBox="0 0 37.183 30.217">
                                        <path
                                            className="a"
                                            d="M1708.711,6236.973c14.031,0,21.7-11.622,21.7-21.7,0-.33-.007-.659-.022-.985a15.525,15.525,0,0,0,3.806-3.95,15.227,15.227,0,0,1-4.382,1.2,7.663,7.663,0,0,0,3.355-4.221,15.289,15.289,0,0,1-4.844,1.852,7.635,7.635,0,0,0-13,6.957,21.65,21.65,0,0,1-15.723-7.97,7.632,7.632,0,0,0,2.361,10.186,7.563,7.563,0,0,1-3.456-.957c0,.032,0,.064,0,.1a7.635,7.635,0,0,0,6.12,7.48,7.606,7.606,0,0,1-3.444.131,7.634,7.634,0,0,0,7.126,5.3,15.3,15.3,0,0,1-9.476,3.267,15.546,15.546,0,0,1-1.819-.105,21.6,21.6,0,0,0,11.694,3.425"
                                            transform="translate(-1697.017 -6206.756)"
                                        />
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                id="p_lt_ctl02_CS_FooterLinks_smLinkedIn"
                                className="cs-icon-linkedin"
                                title="LinkedIn"
                                href="http://www.linkedin.com/company/citysprint">
                                <span className="icon-social-media">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="37.493"
                                        height="37.938"
                                        viewBox="0 0 37.493 37.938">
                                        <path
                                            className="a"
                                            d="M1769.461,6203.982h-29.934a3.786,3.786,0,0,0-3.78,3.793v30.352a3.786,3.786,0,0,0,3.78,3.793h29.934a3.786,3.786,0,0,0,3.78-3.793v-30.352A3.786,3.786,0,0,0,1769.461,6203.982ZM1747.778,6234h-5.044v-16.228h5.044Zm-2.555-18.22a2.527,2.527,0,1,1,2.721-2.521A2.514,2.514,0,0,1,1745.223,6215.78ZM1766.2,6234h-5.045v-8.994c0-2.091-.729-3.518-2.555-3.518a2.77,2.77,0,0,0-2.587,1.891,3.612,3.612,0,0,0-.168,1.264V6234H1750.8v-11.052c0-2.023-.065-3.715-.133-5.176h4.382l.231,2.255h.1a5.825,5.825,0,0,1,5.01-2.621c3.318,0,5.808,2.224,5.808,7Z"
                                            transform="translate(-1735.747 -6203.982)"
                                        />
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                id="p_lt_ctl02_CS_FooterLinks_smYouTube"
                                className="cs-icon-youtube"
                                title="YouTube"
                                href="http://www.youtube.com/user/CitySprintUK">
                                <span className="icon-social-media">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="56.208"
                                        height="34.539"
                                        viewBox="0 0 56.208 34.539">
                                        <path
                                            className="a"
                                            d="M1833.513,6210.485a6.672,6.672,0,0,0-4.97-4.363c-4.383-1.03-21.959-1.03-21.959-1.03s-17.576,0-21.961,1.03a6.666,6.666,0,0,0-4.968,4.363c-1.176,3.848-1.176,11.877-1.176,11.877s0,8.028,1.176,11.875a6.669,6.669,0,0,0,4.968,4.363c4.385,1.03,21.961,1.03,21.961,1.03s17.576,0,21.959-1.03a6.676,6.676,0,0,0,4.97-4.363c1.174-3.847,1.174-11.875,1.174-11.875S1834.687,6214.333,1833.513,6210.485Zm-32.55,19.278v-14.8l14.6,7.4Z"
                                            transform="translate(-1778.479 -6205.091)"
                                        />
                                    </svg>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="cs-footer-links-wrapper">
                <nav className="cs-footer-links">
                    <div className="cs-footer-links-column">
                        <a href={`${CS_URL}/about-us`}>About us</a>

                        <ul>
                            <li>
                                <a href={`${CS_URL}/about-us/our-vision`}>
                                    Our vision
                                </a>
                            </li>

                            <li>
                                <a
                                    href={`${CS_URL}/about-us/awards-and-accreditations`}>
                                    Awards
                                </a>
                            </li>

                            <li>
                                <a href={`${CS_URL}/about-us/case-studies`}>
                                    Case studies
                                </a>
                            </li>

                            <li>
                                <a
                                    href={`${CS_URL}/about-us/national-coverage`}>
                                    Nationwide coverage
                                </a>
                            </li>

                            <li>
                                <a
                                    href={`${CS_URL}/covid-secure-at-citysprint`}>
                                    COVID-19 secure
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="cs-footer-links-column">
                        <a href={`${CS_URL}/careers`}>Work with us</a>

                        <ul>
                            <li>
                                <a href="https://careers.citysprint.co.uk">
                                    Careers
                                </a>
                            </li>

                            <li>
                                <a
                                    href={`${CS_URL}/about-us/sell-your-business`}>
                                    Sell your business
                                </a>
                            </li>

                            <li>
                                <a href={`${CS_URL}/couriers`}>
                                    Become a courier
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="cs-footer-links-column">
                        <a href={`${CS_URL}/support`}>Support </a>

                        <ul>
                            <li>
                                <a href={`${CS_URL}/contact-us`}>Contact us</a>
                            </li>

                            <li>
                                <a href={`${CS_URL}/support/resources`}>
                                    Guides and resources
                                </a>
                            </li>

                            <li>
                                <a href="https://go.citysprint.co.uk/get-started">
                                    Sign up with CitySprint
                                </a>
                            </li>

                            <li>
                                <a
                                    href={`${CS_URL}/account/activate-your-online-account`}>
                                    Activate your online account
                                </a>
                            </li>

                            <li>
                                <a href={`${CS_URL}/locations-lookup`}>
                                    Locations
                                </a>
                            </li>

                            <li>
                                <a href={`${CS_URL}/brexit`}>Brexit guidance</a>
                            </li>
                        </ul>
                    </div>
                    <div className="cs-footer-links-column">
                        <a href={`${CS_URL}/insights`}>Insights</a>

                        <ul>
                            <li>
                                <a href={`${CS_URL}/collaborate-uk`}>
                                    Collaborate UK
                                </a>
                            </li>

                            <li>
                                <a href={`${CS_URL}/news`}>News</a>
                            </li>

                            <li>
                                <a href={`${CS_URL}/blog`}>Blog</a>
                            </li>
                        </ul>
                    </div>
                    <div className="cs-footer-links-column">
                        <a href={`${CS_URL}/payment-options`}>
                            Payments and charges
                        </a>

                        <ul>
                            <li>
                                <a href={`${CS_URL}/fuel-surcharges`}>
                                    Fuel surcharges
                                </a>
                            </li>

                            <li>
                                <a href={`${CS_URL}/indemnity-request`}>
                                    Indemnity request
                                </a>
                            </li>

                            <li>
                                <a
                                    href={`${CS_URL}/public-liability-insurance`}>
                                    Public liability insurance
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="cs-footer-links-column cs-footer-links-generic">
                        <div className="cs-other-services-wrapper">
                            <button
                                id="p_lt_ctl02_CS_FooterLinks_hypServices"
                                className="cs-other-services-link"
                                onClick={() => {
                                    setShowOtherSites(!showOtherSites)
                                }}>
                                <Row className="text-white mb-4">
                                    Other sites
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-4 w-4 mt-1 ml-1"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M19 9l-7 7-7-7"
                                        />
                                    </svg>
                                </Row>
                            </button>
                            {showOtherSites && (
                                <div className="cs-other-services-bubble">
                                    <ul>
                                        <li>
                                            <a
                                                href={`${CS_URL}/courier-services/Retail-delivery-services`}>
                                                On the dot
                                            </a>
                                        </li>

                                        <li>
                                            <a href="https://www.citysprinthealth.co.uk/">
                                                CitySprint Health
                                            </a>
                                        </li>

                                        <li>
                                            <a href="https://www.citysprintoffice.co.uk/">
                                                CitySprint Office
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </nav>
            </div>

            <div className="footer-bottom-wrapper">
                <div className="logo-strapline">
                    <div className="footer-logo">
                        <a
                            id="p_lt_ctl02_CS_SubFooterLinks_hypSiteURL"
                            href="/">
                            <img
                                id="p_lt_ctl02_CS_SubFooterLinks_imgLogo"
                                className="cs-site-header-logo"
                                src="https://cs-aws-uks-static-fqcbhahmb9d6bcg2.a02.azurefd.net/logos/citySprint-logo.png"
                                alt="CS.MainLogoAltText"
                            />
                        </a>
                    </div>
                    <h4 className="footer-strapline">
                        Delivering what matters.
                    </h4>
                </div>

                <nav className="cs-sub-footer-links">
                    <div className="cs-sub-footer-copyright">
                        Copyright © 2021 CitySprint (UK) Ltd
                    </div>

                    <ul>
                        <li>
                            <a href={`${CS_URL}/gdpr`}>GDPR</a>
                        </li>

                        <li>
                            <a href={`${CS_URL}/terms-and-conditions`}>
                                Terms and conditions
                            </a>
                        </li>

                        <li>
                            <a href={`${CS_URL}/cookies`}>Cookies policy</a>
                        </li>

                        <li>
                            <a href={`${CS_URL}/modern-slavery-act`}>
                                Modern slavery statement
                            </a>
                        </li>

                        <li>
                            <a href={`${CS_URL}/privacy-policy`}>
                                Privacy policy
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </footer>
    )
}
